import React, { useState } from "react";
import {
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./NavbarMobile.css";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import sidebarLinks from "../../utils/sidebarLinks";

const homeLinks = [
  {
    name: "Home",
    link: "/",
  },
];

const dashboardSidebarLinks = [
  {
    name: "Home",
    link: "/",
    img: "/images/home.png",
    img2: "/images/home2.png",
  },
  {
    name: "Digital Gold",
    link: "/dashboard/gold/buy",
    img: "/images/gold_shield.png",
  },
  {
    name: "Digital Silver",
    link: "/dashboard/silver/buy",
    img: "/images/silver_shield.png",
  },
  {
    name: "History",
    link: "/dashboard/history",
    img: "/images/historyHome.png",
    img2: "/images/history2.png",
  },
  {
    name: "Portfolio",
    link: "/dashboard/portfolio",
    img: "/images/portfolioHome.png",
    img2: "/images/portfolio2.png",
  },
  {
    name: "Profile",
    link: "/dashboard/profile",
    img: "/images/profileHome.png",
    img2: "/images/profile2.png",
  },
];

const ResponsiveNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const token = sessionStorage.getItem("token");
  const linksToMap = location.pathname.includes("/dashboard")
    ? sidebarLinks
    : homeLinks;
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredIndex, setHoveredIndex] = React.useState(null);

  return (
    <div className="responsive_navbar">
      <Tooltip title="Menu">
        {/* <IconButton
          onClick={() => setIsOpen(!isOpen)}
          size="small"
          sx={{ ml: 1 }}
        > */}

        <button
          onClick={() => setIsOpen(!isOpen)}
          style={{
            marginLeft: "10px",
            backgroundColor: "white",
            border: "none",
          }}
        >
          <img
            src="/images/menu_button.png"
            alt="menu_button"
            height="30px"
            width="45px"
            style={{ display: "flex", marginRight: 1 }}
          />
        </button>
        {/* </IconButton> */}
      </Tooltip>

      <div className={`side-nav ${isOpen ? "open" : ""}`}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "1rem",
          }}
        >
          <div>
            {/* <Link to="/">
            <img
              src="/images/BajajLogo.png"
              alt="Bajaj_logo"
              width={157}
              height={22}
            />
          </Link> */}
          </div>
          <CloseIcon
            fontSize="large"
            color="#510d10"
            onClick={() => setIsOpen(!isOpen)}
          />
        </div>
        <nav
          style={{
            width: "100%",
            // height: "100dvh",
            display: "flex",
            justifyContent: "center",
            gap: "1rem",
            flexDirection: "column",
            // marginTop: "10rem",
          }}
        >
          {linksToMap?.map((item, index) => (
            <NavLink
              to={item.link}
              onClick={() => setIsOpen(false)}
              key={index}
              // className={({ isActive }) =>
              //   isActive ? "active-link" : "sidebar-link"
              // }
              className={() => {
                if (item.type === "home") return "sidebar-link";

                // Handle special case where "gold" should not be active on "gold-sip"
                if (
                  item.type === "gold" &&
                  location.pathname.startsWith("/dashboard/gold-sip")
                )
                  return "sidebar-link";

                if (
                  item.type === "silver" &&
                  location.pathname.startsWith("/dashboard/silver-sip")
                )
                  return "sidebar-link";

                // Active condition for items with `active` path
                if (item.active && location.pathname.startsWith(item.active)) {
                  return "active-link";
                }

                // Fallback to normal matching
                return location.pathname.startsWith(item.link)
                  ? "active-link"
                  : "sidebar-link";
              }}
            >
              <ListItem
                disablePadding
                sx={{ display: "flex", justifyContent: "center" }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <ListItemButton>
                  <div
                    style={{
                      margin: "0px",
                      fontSize: "1.5rem",
                      display: "flex",
                      gap: "1rem",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {item?.img && (
                      <ListItemIcon>
                        <img
                          src={
                            window.location.pathname === item.link ||
                            hoveredIndex === index
                              ? item.img2 || item.img
                              : item.img
                          }
                          alt={item.name}
                          width={35}
                        />
                      </ListItemIcon>
                    )}
                    <div>{item.name}</div>
                    {/* {item.name == "Digital Saving" && <IoIosArrowDown />} */}
                  </div>
                </ListItemButton>
              </ListItem>
            </NavLink>
          ))}

          {!token && (
            <div style={{ display: "flex", padding: "8px 16px" }}>
              <button
                onClick={() => {
                  navigate("/login");
                  setIsOpen(!isOpen);
                }}
                style={{
                  padding: "0.5rem 2rem",
                  border: "2px solid #DA2128",
                  borderRadius: "4px",
                  backgroundColor: "white",
                  color: "#C62128",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                }}
              >
                Login
              </button>
            </div>
          )}
        </nav>
      </div>
    </div>
  );
};

export default ResponsiveNavbar;
